import { render, staticRenderFns } from "./diagnoseReport.vue?vue&type=template&id=b1fb01e6&scoped=true"
import script from "./diagnoseReport.vue?vue&type=script&lang=js"
export * from "./diagnoseReport.vue?vue&type=script&lang=js"
import style0 from "./diagnoseReport.vue?vue&type=style&index=0&id=b1fb01e6&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b1fb01e6",
  null
  
)

export default component.exports